/*
 * Filename: field-details.model.ts
 * 
 */

import { types, ModelInstanceTypeProps, ModelProperties } from 'mobx-state-tree';
import { fieldDetailsHelper } from './field-details-model.helper';
import { CQMasterDataStore } from '../../store/cq-master-data.store';



export const FieldDetails = types.model({
    selectedFieldDetailsObject: types.optional(types.frozen(), {}),
    fields: types.optional(types.frozen(), {}),
}).actions((self: ModelInstanceTypeProps<ModelProperties>) => ({
    setSelectedFieldDetailsObject(selectedField: {}) {
        self.selectedFieldDetailsObject = selectedField;
    },
    setFields(fields: {}) {
        self.fields = fields;
        CQMasterDataStore.Details.setAppliedRuleObject();
    },
    setAppliedRuleObject() {
        const RuleObject: any = CQMasterDataStore.RulesObject.FieldRuleObject;
        let fields: any = { ...self.fields };
        if (Object.keys(RuleObject).length > 0) {
            const fieldKeys = Object.keys(self.fields);
            fields = fieldDetailsHelper.setAppliedRuleObject(fieldKeys, RuleObject, fields);
        } else {
           fields =  fieldDetailsHelper.setAppliedRuleHelper(self.fields ,fields);
        }
        self.fields = fields;
    }
}));
